<template>
  <div>
    <div class="widewrapper main">
        <div class="container about info">
            <h1>Zhen <span class="about-bold">Fan</span></h1>
            <p>Phone: &nbsp;18513417479</p>
            <p>Email: &nbsp;912504432@qq.com</p>

            <h3><span class="about-bold">SomeThing I've Done</span></h3>
            <p><a href="https://space.bilibili.com/170114361/channel/detail?cid=19971" target="_blank">翻译 Crash Course Computer Science 系列 [ B站 ]</a></p>

            <div class="about-button">
                <router-link class="btn btn-xlarge btn-clean-one" to="/contact">给我留言</router-link>
            </div>
            <hr>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Me',
  metaInfo: {
      meta: [
          { name: 'keywords', content: '范祯的博客' },
          { name: 'description', content: '前360资深研发，分享些有趣好玩的东西' }
      ]
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Me.vue